import { useRef, useState } from "react";
import { Play } from "lucide-react";
import { Reveal, ChapterTag } from "@/components/Reveal";

export const VideoSection = () => {
  const videoRef = useRef(null);
  const [started, setStarted] = useState(false);

  const play = () => {
    videoRef.current?.play();
    setStarted(true);
  };

  return (
    <section id="vision-video" data-testid="video-section" className="scroll-mt-24 bg-[#074345] py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <Reveal>
            <div className="flex justify-center">
              <ChapterTag number="03" label="The Film" dark />
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 text-[1.9rem] font-extrabold leading-tight tracking-tight text-[#F7F1E6] sm:text-4xl lg:text-[2.6rem]">
              See the Peanut Valet vision.
            </h2>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mt-5 text-base leading-relaxed text-[#EADCC6] sm:text-lg">
              Take a closer look at the design, the details and the personality behind
              Peanut Valet.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15} y={40} className="mx-auto mt-12 max-w-5xl">
          <div className="relative overflow-hidden rounded-[2rem] shadow-[0_50px_100px_-40px_rgba(0,0,0,0.6)] ring-1 ring-[#115B5B]">
            <video
              ref={videoRef}
              data-testid="video-player-element"
              className="aspect-video w-full bg-[#043436]"
              poster="/assets/peanut-valet-video-poster.webp"
              preload="none"
              playsInline
              controls={started}
              onEnded={() => setStarted(false)}
              aria-label="Peanut Valet design vision video. This video has no sound."
            >
              <source src="/assets/peanut-valet-vision.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {!started && (
              <button
                type="button"
                data-testid="video-play-button"
                onClick={play}
                aria-label="Play the Peanut Valet vision video"
                className="absolute inset-0 grid place-items-center bg-[#043436]/10 transition-colors duration-300 hover:bg-[#043436]/25"
              >
                <span className="pulse-ring relative grid h-20 w-20 place-items-center rounded-full bg-[#F3802A] shadow-[0_20px_50px_-10px_rgba(243,128,42,0.7)] transition-transform duration-300 hover:scale-110 sm:h-24 sm:w-24">
                  <Play className="h-8 w-8 fill-[#043436] text-[#043436] sm:h-9 sm:w-9" aria-hidden="true" />
                </span>
              </button>
            )}
          </div>
          <p className="mt-4 text-center text-sm text-[#EADCC6]/70" data-testid="video-caption">
            Rendered visuals of the design in development. This video is intentionally silent.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
